import React,{Component} from 'react';
import WorkerListView from './WorkerListView';
import Notification from './Notification';
class ForemanView extends Component{

  constructor(props){
    super(props);
  }

  render(){
    const usersListButton = this.props.isAdmin == true ? <button className="btnFirstButton" onClick={this.props.changeToUsersView}  >
    Käyttäjät
</button>: <></>;
    return(
      <div> 
    <WorkerListView workers={this.props.workers} changeWorker={this.props.changeWorker} deleteWorker={this.props.deleteWorker} showInMap={this.props.showInMap} changePasswordView={this.props.changePasswordView} isAdmin={this.props.isAdmin}/>
    {usersListButton}
    <button className="btnSecondButton" onClick={this.props.changeToAddWorkerView}  >
        Lisää työntekijä
    </button>
    <button className="btnThirdButton" onClick={this.props.changeToPostingView}  >
        Komennusmiehet
    </button>
    <button className="btnClose" onClick={this.props.changeToConfigView}  >
        Aseta aikarajat
    </button>
 
    </div>
)
}
}
export default ForemanView;
